module.exports = __webpack_public_path__ + "dbeabf204cd5193043918bee0978e805.png";